import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import * as _ from 'lodash';

import TextField from '@material-ui/core/TextField';
import Slide from '@material-ui/core/Slide';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';

import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import Badge from '@material-ui/core/Badge';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Grid from '@material-ui/core/Grid';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepButton from '@material-ui/core/StepButton';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
// import Timer from 'react-compound-timer';
import MuiPhoneNumber from 'material-ui-phone-number';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';

import { CategoriesNavigation, CategoryProductsNavigation, ShoppingCart, HighlightedProducts, dateToLocale } from '../components/ProductNavigation';
import * as OrdersClient from '../clients/Orders';
// import PostalCodes from '../model/PostalCodes';
import * as Legal from '../components/Legal';
import * as Home from '../components/Home';
import logo from '../images/logo.jpg';
import bannerHome from '../images/banner-top.jpg';
import icons from '../images/icons';

function filterProductsOnSale(product) {
    return (product.dateTo !== undefined || product.dateFrom !== undefined) && product.imageUrl !== undefined;
}

const styles = (theme) => ({
    root: {
        // padding: 40,
        position: 'relative',
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
    },
    paperHighlight: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
        backgroundColor: '#eee',
        paddingBottom: theme.spacing(4),
    },
    paperRed: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
        border: '1px solid #db0030',
        boxShadow: 'none',
    },
    stepper: {
        backgroundColor: 'transparent',
    },
    button: {
        margin: theme.spacing(1),
    },
    textInput: {
        marginRight: theme.spacing(1) * 3,
        width: 250,
    },
    textInputShort: {
        marginRight: theme.spacing(1) * 3,
        width: 125,
    },
    textInputSemiSemiLong: {
        marginRight: theme.spacing(1) * 3,
        width: 312,
    },
    textInputSemiLong: {
        marginRight: theme.spacing(1) * 3,
        width: 400,
    },
    textInputLong: {
        marginRight: theme.spacing(1) * 3,
        width: 500,
    },
    textInputFullwidth: {
        marginRight: theme.spacing(1) * 3,
        width: 925,
    },
});

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: 29,
        top: 4,
        border: 'none', //`2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}))(Badge);

const StyledBadgeSmartphone = withStyles((theme) => ({
    badge: {
        left: 21,
        top: -16,
        border: `1px solid #db0030`,
        padding: '0 4px',
    },
}))(Badge);

class OrdersInternal extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            cart: [],
            alertOpen: false,
            activeStep: 0,
            alertMessage: '',
            alertSeverity: 'success',

            dialogOpen: false,
            dialogTitle: '',
            dialogSize: 'sm', // 'lg

            loading: false,
            weekNumber: 0,
            customer: {
                name: '',
                // surname: '',
                // surname2: '',
                email: '',
                phone: '+34',
                loyaltyCode: '',
                address: '',
                city: '',
                postalCode: undefined,
            },
            customerError: {
                name: true,
                // surname: true,
                // surname2: true,
                identifier: true,
                email: false,
                phone: true,
                loyaltyCode: true,
                address: true,
                city: true,
            },
            amount: 0,
            storePickUp: false,
            homeDeliveryStep: false,
            totalQty: 0,
            category: undefined,
            categories: [],
            products: [],
            orderDeliveryDate: undefined,
            orderDeliveryTime: undefined,
            orderAvailableDates: [],
            shoppingCartVisible: false,
            disclamerAccepted: false,
            disclamerLoyaltyCard: false,
            showHighlightedProducts: true,
        };

        // Dummy data
        // this.state.orderVerified = false;
        // this.state.activeStep = 2;
        // this.state.customer = {
        //     name: 'Francesc',
        //     surname: 'Galbany',
        //     surname2: 'Duran',
        //     email: 'francesc@wenablesolutions.com',
        //     phone: '+34600661179',
        //     loyaltyCode: '123456',
        //     address: 'Lledoners 666',
        //     city: 'Cabrils',
        //     postalCode: '07001',
        // };
        // this.state.orderAvailableDates = [{ date: '2020-05-01T00:00:00.000Z', avalable: true }];
        // this.state.orderDeliveryDate = '2020-05-01T00:00:00.000Z';
        // this.state.shoppingCartVisible = false;
        // this.state.cart = [
        //     { category: 'Cerdo Fresco', id: 2105, name: 'COSTILLEJA CERDO TIRA', gr: 0.5, format: 'BANDEJA 2 UDS', price: 3.165, priceKg: 6.33, unit: 'KG', quantity: 6, amount: 18.990000000000002 },
        //     {
        //         category: 'Cerdo Fresco',
        //         id: 2100,
        //         name: 'LOMO CERDO FILETEADO',
        //         cut: 'PLANCHA 100 GR',
        //         gr: 0.1,
        //         format: 'BANDEJA 24 FILETES',
        //         price: 13.56,
        //         priceKg: 5.65,
        //         unit: 'KG',
        //         quantity: 1,
        //         amount: 13.56,
        //     },
        //     {
        //         category: 'Cerdo Fresco',
        //         id: 2100,
        //         name: 'LOMO CERDO FILETEADO',
        //         cut: 'FINO 70 GR',
        //         gr: 0.07,
        //         format: 'BANDEJA 24 FILETES',
        //         price: 9.492,
        //         priceKg: 5.65,
        //         unit: 'KG',
        //         quantity: 3,
        //         amount: 28.476000000000003,
        //     },
        // ];
        // this.state.amount = 61.02600000000001;
        // this.state.totalQty = 10;
    }

    componentDidMount() {
        OrdersClient.getAllCategories()
            .then((categories) => {
                this.setState({ categories });

                OrdersClient.getAllProducts().then((products) => {
                    this.setState({ products, productsOnSale: products.filter(filterProductsOnSale) });
                });
            })
            .catch((err) => {
                this.showMessage(`${err.errorMessage.split(']')[1].trim()}`, 'error');
            });
    }

    onCustomerDataChange = (event) => {
        let customer = _.cloneDeep(this.state.customer);
        let customerError = _.cloneDeep(this.state.customerError);
        customer[event.target.name] = event.target.value !== '' ? event.target.value : undefined;

        // Validació

        switch (event.target.name) {
            case 'postalCode':
                customerError[event.target.name] = event.target.value !== '' ? false : true;
                break;
            case 'name':
            // case 'surname':
            // case 'surname2':
            case 'identifier':
            case 'address':
            case 'city':
                customerError[event.target.name] = event.target.value !== '' ? false : true;
                break;
            case 'email':
                if (event.target.value === '') {
                    customerError[event.target.name] = this.state.storePickUp;
                } else {
                    customerError[event.target.name] = !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(event.target.value);
                }
                break;
            case 'phone':
                if (event.target.value === '') {
                    customerError[event.target.name] = true;
                } else {
                    customerError[event.target.name] = !/\+([0-9 ]{10,20})+$/.test(event.target.value);
                }
                break;
            case 'loyaltyCode':
                if (event.target.value === '' && this.state.disclamerLoyaltyCard === true) {
                    customerError[event.target.name] = false;
                } else {
                    customerError[event.target.name] = event.target.value !== '' && event.target.value.length === 6 ? !/([0-9 ])+$/.test(event.target.value) : true;
                }
                break;
            default:
                break;
        }

        // if (event.target.name === 'postalCode') {
        //     customer['city'] = PostalCodes[event.target.value];
        // }
        // TODO: Check customer fields validity and completness
        this.setState({ customer, customerError }, this.checkCustomerFields);
    };

    onLoyaltyCardFieldsChange = () => {
        let { loyaltyCode, identifier } = this.state.customer;

        if (loyaltyCode !== '' && loyaltyCode !== undefined && identifier !== '' && identifier !== undefined) {
            OrdersClient.getLoyaltyCard(loyaltyCode, identifier)
                .then((data) => {
                    this.onCustomerDataChange({ target: { name: 'name', value: data.name } });
                    // this.onCustomerDataChange({ target: { name: 'surname', value: data.surname } });
                    // this.onCustomerDataChange({ target: { name: 'surname2', value: data.surname2 } });

                    if (this.state.customer.postalCode === data.postalCode.trim() || this.state.storePickUp) {
                        this.onCustomerDataChange({ target: { name: 'address', value: data.address } });
                        this.onCustomerDataChange({ target: { name: 'city', value: data.city } });
                        if (this.state.storePickUp) {
                            this.onCustomerDataChange({ target: { name: 'postalCode', value: data.postalCode.trim() } });
                        }
                    }

                    this.onCustomerDataChange({ target: { name: 'email', value: data.email } });
                    this.onCustomerDataChange({ target: { name: 'phone', value: `+34${data.phone}` } });
                    this.showMessage(
                        <>
                            Hemos rellenado los datos en base a los obtenidos de su tarjeta.
                            <br />
                            <strong>COMPRUEBE que todos los datos sean correctos</strong>
                        </>,
                        'info',
                        true,
                        'Datos de tarjeta de fidelización'
                    );
                })
                .catch((err) => {
                    this.showMessage(
                        <>
                            El DNI no coincide con el número de la tarjeta de fidelización. <br />
                            Si no encuentra un DNI válido deberá marcar la casilla <strong>"NO tengo tarjeta de fidelización"</strong> para continuar
                        </>,
                        'error',
                        true,
                        'DNI no coincidente'
                    );
                    this.onCustomerDataChange({ target: { name: 'identifier', value: '' } });
                });
        }
    };

    onPhoneChanged = (phoneNumber) => {
        let customer = _.cloneDeep(this.state.customer);
        let customerError = _.cloneDeep(this.state.customerError);
        customer['phone'] = phoneNumber !== '' ? phoneNumber : undefined;
        if (phoneNumber === '') {
            customerError['phone'] = true;
        } else {
            customerError['phone'] = !/\+([0-9 ]{10,20})+$/.test(phoneNumber);
        }
        // TODO: Check customer fields validity and completness
        this.setState({ customer, customerError }, this.checkCustomerFields);
    };

    checkCustomerFields = () => {
        for (let v of Object.values(this.state.customerError)) {
            // Error
            if (v === true) {
                this.setState({ customerFieldsValid: false });
                return;
            }
        }
        this.setState({ customerFieldsValid: true });
    };

    onChange = (event) => {
        let state = _.cloneDeep(this.state);
        state[event.target.name] = event.target.value;
        this.setState(state);
    };

    onToggleDisclammer = (event) => {
        this.setState({ disclamerAccepted: !this.state.disclamerAccepted }, this.checkCustomerFields);
    };

    onToggleLoyaltyProgramCardDisclammer = (event) => {
        let customer = _.cloneDeep(this.state.customer);
        let customerError = _.cloneDeep(this.state.customerError);
        // if (
        //     ((this.state.customer.loyaltyCode === '' && this.state.customer.loyaltyCode.trim().length === 6) || this.state.customer.loyaltyCode === undefined) &&
        //     this.state.disclamerLoyaltyCard === true
        // ) {
        //     customerError['loyaltyCode'] = false;
        // } else if (this.state.disclamerLoyaltyCard === false) {
        //     customerError['loyaltyCode'] = this.state.customer.loyaltyCode === '' || this.state.customer.loyaltyCode === undefined ? false : true;
        // } else {
        //     customerError['loyaltyCode'] = true;
        // }
        //
        // // If we are going to check, delete
        // if (!this.state.disclamerLoyaltyCard) {
        //     customer['loyaltyCode'] = '';
        // }
        customer['loyaltyCode'] = '';
        customerError['loyaltyCode'] = this.state.disclamerLoyaltyCard; // New value
        this.setState({ disclamerLoyaltyCard: !this.state.disclamerLoyaltyCard, customer, customerError }, this.checkCustomerFields);
    };

    setDeliveredDate = (deliveryDate) => {
        this.setState({ orderDeliveryDate: deliveryDate, orderDeliveryTime: undefined }, () => {
            try {
                window.scrollTo(0, 300);
            } catch (err) {}
        });
    };

    setDeliveredTime = (deliveryTime) => {
        this.setState({ orderDeliveryTime: deliveryTime }, () => {
            try {
                window.scrollTo(0, 300);
            } catch (err) {}
        });
    };

    showMessage = (alertMessage, alertSeverity, dialog = false, dialogTitle = undefined) => {
        if (dialogTitle === undefined) {
            if (alertSeverity === 'error') {
                dialogTitle = '¡Lo sentimos!';
            }
        }
        this.setState({ alertMessage, alertSeverity, alertOpen: alertSeverity !== 'error' && !dialog ? true : false, dialogOpen: alertSeverity !== 'error' && !dialog ? false : true, dialogTitle });
        clearTimeout(this.alertTimerId);
        this.alertTimerId = setTimeout(() => this.setState({ alertOpen: false }), 2000);
    };

    handleCloseAllDialogs = () => {
        this.setState({ alertOpen: false, dialogOpen: false });
    };

    handleShowHighlightedProducts = () => {
        this.setState({ showHighlightedProducts: true });
    };

    handleCloseHighlightedProducts = () => {
        this.setState({ showHighlightedProducts: false });
    };

    toggleCartVisible = () => {
        this.setState({ shoppingCartVisible: !this.state.shoppingCartVisible });
    };

    addToCart = (product) => {
        let cart = _.cloneDeep(this.state.cart);
        let found = false;
        let amount = 0;
        // For the alert message
        let productQuantity = 1;
        for (let p of cart) {
            if (p.id === product.id && p.cut === product.cut && p.format === product.format) {
                p.quantity++;
                p.amount = p.quantity * p.price;
                productQuantity = p.quantity;
                found = true;
                break;
            }
        }
        if (!found) {
            product.quantity = 1;
            product.amount = product.price;
            cart.push(product);
        }
        let totalQty = 0;
        for (let p of cart) {
            amount += p.amount;
            totalQty += p.quantity;
        }
        //this.showMessage(`${product.name} ${product.cut !== undefined ? product.cut : ''} ${product.format !== undefined ? product.format : ''} añadido al carrito`, 'info');
        this.showMessage(
            <>
                {product.name}
                <br />
                añadido al carrito ({productQuantity} unidades)
            </>,
            'info'
        );
        this.setState({ cart, amount, totalQty });
    };

    removeFromCart = (product, qty) => {
        let cart = _.cloneDeep(this.state.cart);
        let found = false;
        let amount = 0;
        let index = 0;
        for (let p of cart) {
            if (p.id === product.id && p.cut === product.cut && p.format === product.format) {
                found = true;
                break;
            }
            index++;
        }
        if (found) {
            if (qty === undefined || cart[index].quantity - qty <= 0) {
                cart.splice(index, 1);
            } else {
                cart[index].quantity -= qty;
                cart[index].amount = cart[index].quantity * cart[index].price;
            }
        }
        let totalQty = 0;
        for (let p of cart) {
            amount += p.amount;
            totalQty += p.quantity;
        }

        this.setState({ cart, amount, totalQty });
    };

    checkPostalCode = (evt) => {
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }
        if (this.state.customer.postalCode && this.state.customer.postalCode.trim().length === 5) {
            OrdersClient.checkRouteAvailability(this.state.customer.postalCode)
                .then((orderAvailableDates) => {
                    if (orderAvailableDates.some((d) => d.available)) {
                        this.setState({ orderAvailableDates }, this.checkConfirmExit);
                    } else {
                        this.showMessage('No hay reparto disponible en tu población en menos de dos semanas. Por favor contactanos por teléfono.', 'error', true);
                    }
                })
                .catch((err) => {
                    this.showMessage(`${err.errorMessage.split(']')[1].trim()}`, 'error');
                });
        }
    };

    checkStorePickup = (evt) => {
        if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
        }

        OrdersClient.checkStorePickupAvailability()
            .then((orderAvailableDates) => {
                if (orderAvailableDates.some((d) => d.ranges.some((r) => r.available))) {
                    for (let i = 0; i < orderAvailableDates.length; i++) {
                        orderAvailableDates[i].available = orderAvailableDates[i].ranges.some((r) => r.available);
                    }

                    let customerError = _.cloneDeep(this.state.customerError);
                    customerError['postalCode'] = true;
                    customerError['email'] = true;
                    let customer = _.cloneDeep(this.state.customer);
                    customer.postalCode = ''; // Managed state
                    this.setState({ orderAvailableDates, storePickUp: true, customerError, customer }, this.checkConfirmExit);
                } else {
                    this.showMessage('No disponemos de más espacio para recogidas en tienda en menos de dos semanas. Por favor contactanos por teléfono.', 'error', true);
                }
            })
            .catch((err) => {
                this.showMessage(`${err.errorMessage.split(']')[1].trim()}`, 'error');
            });
    };

    createOrder = () => {
        if (this.state.loading !== true) {
            this.setState({ loading: true });
            OrdersClient.create(this.state.customer, this.state.cart, this.state.orderDeliveryDate, this.state.orderDeliveryTime, this.state.storePickUp)
                .then((data) => {
                    this.setState({ orderId: data.id, loading: false }, this.nextStep);
                })
                .catch((err) => {
                    this.showMessage(`${err.errorMessage.split(']')[1].trim()}`, 'error');
                    this.setState({ loading: false });
                });
        } else {
        }
    };

    verifyOrder = () => {
        OrdersClient.verify(this.state.orderId, this.state.verificationCode)
            .then((data) => {
                this.showMessage('¡Pedido completado!', 'success');
                this.setState({ orderVerified: true, verifiedOrderDeliveryTime: data.deliveryTime }, this.checkConfirmExit);
            })
            .catch((err) => {
                this.showMessage(`${err.errorMessage.split(']')[1].trim()}`, 'error');
            });
    };

    getSteps = () => {
        return ['Selecciona día de entrega', 'Selecciona tus productos', 'Introduce tus datos', ' Finaliza tu pedido'];
    };

    nextStep = () => {
        this.setState(
            {
                activeStep: this.state.activeStep + 1,
            },
            this.checkConfirmExit
        );
    };

    prevStep = () => {
        this.setState(
            {
                activeStep: this.state.activeStep - 1,
            },
            this.checkConfirmExit
        );
    };

    goToStep = (step) => {
        this.setState(
            {
                activeStep: step,
            },
            this.checkConfirmExit
        );
    };

    checkConfirmExit = () => {
        if (this.state.activeStep === 1) {
            window.onbeforeunload = () => {
                return 'Si cierra la ventana ahora cancelará el proceso de compra, ¿desea continuar?';
            };
        } else if (this.state.activeStep === 3 && this.state.orderVerified === true) {
            window.onbeforeunload = undefined;
        }
        try {
            window.scrollTo(0, 0);
        } catch (err) {}
    };

    nextWeek = () => {
        this.setState({
            weekNumber: Math.min(this.state.weekNumber + 1, this.state.orderAvailableDates.length / 7 - 1),
        });
    };

    prevWeek = () => {
        this.setState({
            weekNumber: Math.max(this.state.weekNumber - 1, 0),
        });
    };

    showCategory = (category) => {
        OrdersClient.getAllProducts(category).then((products) => {
            this.setState({ category, products }, this.checkConfirmExit);
        });
    };

    closeCategory = () => {
        this.showCategory(undefined);
    };

    setHomeDelivery = () => {
        this.setState({ homeDeliveryStep: true });
    };

    unsetHomeDelivery = () => {
        this.setState({ homeDeliveryStep: false });
    };

    // setStorePickup = () => {
    //     this.setState({ storePickUp: true });
    // };

    renderRouteForm = () => {
        const wn = this.state.weekNumber;
        const weekdays = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
        let availableDates = [];
        let startDate;
        let endDate;
        if (this.state.orderAvailableDates.length >= (wn + 1) * 7) {
            availableDates = this.state.orderAvailableDates.slice(wn * 7, wn * 7 + 7);

            startDate = dateToLocale(availableDates[0].date);
            endDate = dateToLocale(availableDates[6].date);
        }

        return (
            <div style={{ textAlign: 'center' }}>
                <div className="section-title">{this.state.storePickUp ? '¿CUÁNDO QUIERES RECOGER TU PEDIDO?' : '¿CUÁNDO QUIERES TU PEDIDO?'}</div>
                {availableDates.length > 0 && (
                    <>
                        <div>
                            <div className="date-select-title">
                                Semana del {startDate} al {endDate}
                            </div>
                            <div className="date-select-days">
                                <div className="date-select-arrow-left">
                                    <IconButton size="medium" onClick={this.prevWeek}>
                                        <ArrowBackIosIcon fontSize="large" />
                                    </IconButton>
                                </div>
                                {availableDates.map((d, i) =>
                                    this.props.smartphone !== true || i < 6 ? (
                                        <div
                                            className={`date-select-day-option ${!d.available ? 'date-select-day-option-disabled' : ''} ${
                                                d.date === this.state.orderDeliveryDate ? 'date-select-day-option-selected' : ''
                                            } `}
                                            onClick={() => (d.available ? this.setDeliveredDate(d.date) : '')}
                                            key={d.date}
                                        >
                                            <span className="date-select-day-option-day">{weekdays[i]} </span>
                                            <span className="date-select-day-option-date">{new Date(d.date).getDate()}</span>
                                        </div>
                                    ) : (
                                        <div />
                                    )
                                )}
                                <div className="date-select-arrow-right">
                                    <IconButton size="medium" onClick={this.nextWeek}>
                                        <ArrowForwardIosIcon fontSize="large" />
                                    </IconButton>
                                </div>
                            </div>

                            {this.state.orderDeliveryDate && this.state.storePickUp === true && (
                                <div className="date-select-hour-container">
                                    {availableDates.find((d) => d.date === this.state.orderDeliveryDate) &&
                                        availableDates
                                            .find((d) => d.date === this.state.orderDeliveryDate)
                                            .ranges.map((d, i) =>
                                                this.props.smartphone !== true || i < 6 ? (
                                                    <div
                                                        className={`date-select-hour-option ${!d.available ? 'date-select-hour-option-disabled' : ''} ${
                                                            this.state.orderDeliveryTime &&
                                                            d.rangeStart === this.state.orderDeliveryTime.rangeStart &&
                                                            d.rangeEnd === this.state.orderDeliveryTime.rangeEnd
                                                                ? 'date-select-hour-option-selected'
                                                                : ''
                                                        } `}
                                                        onClick={() => (d.available ? this.setDeliveredTime(d) : '')}
                                                        key={d.rangeStart}
                                                    >
                                                        {d.rangeStart} - {d.rangeEnd}h
                                                    </div>
                                                ) : (
                                                    <div />
                                                )
                                            )}
                                </div>
                            )}
                            <p>
                                {this.state.storePickUp
                                    ? 'Todos los pedidos se podrán recoger de lunes a viernes de 10:30 a 13:30h o de 16:30 a 19:30h y los sábados de 10:30 a 13:30h.'
                                    : 'Todos los pedidos se entregan de lunes a sábado de 9 a 16h.'}
                            </p>
                        </div>
                    </>
                )}

                {this.state.orderDeliveryDate && (this.state.storePickUp === false || this.state.orderDeliveryTime !== undefined) && (
                    <div className="date-select-button-container">
                        <Button onClick={this.nextStep} variant="contained" color="primary" fullWidth={this.props.smartphone}>
                            Confirmar {this.state.storePickUp ? 'recogida' : 'entrega'} para {dateToLocale(this.state.orderDeliveryDate)}
                            {this.state.orderDeliveryTime ? ` entre ${this.state.orderDeliveryTime.rangeStart} y las ${this.state.orderDeliveryTime.rangeEnd}` : ''}
                        </Button>
                        {this.state.storePickUp && <p>Se asignará una hora concreta al finalizar el pedido</p>}
                    </div>
                )}
                <div className="approximate-price-disclamer-pop-up">
                    <strong>Todos nuestros precios son aproximados</strong>
                    <br />
                    El nuestro es un trabajo artesanal realizado por nuestros carniceros, y por tanto, el precio de las bandejas puede variar según el tipo de corte o el tamaño de producto.
                    <br /> <br />
                    <strong>Todos nuestros precios incluyen IVA</strong>
                </div>
            </div>
        );
    };

    renderCustomerForm = () => {
        return (
            <>
                <Paper className={this.props.classes.paperRed}>
                    <div className="checkout-title">Tarjeta de fidelización</div>
                    <TextField
                        className={this.props.classes.textInput}
                        label="Número de tarjeta"
                        margin="normal"
                        name="loyaltyCode"
                        helperText="Últimos 6 dígitos de su tarjeta"
                        required
                        disabled={this.state.disclamerLoyaltyCard}
                        value={this.state.customer.loyaltyCode}
                        onChange={this.onCustomerDataChange}
                        error={this.state.customerError.loyaltyCode}
                        onBlur={this.onLoyaltyCardFieldsChange}
                    />
                    <br />
                    <Checkbox checked={this.state.disclamerLoyaltyCard} color="primary" onChange={this.onToggleLoyaltyProgramCardDisclammer} name={'createLoyaltyProgramCard'} />{' '}
                    <strong>NO tengo tarjeta de fidelización </strong> acepto que se cree una a mi nombre.{' '}
                    <Link
                        component="a"
                        fontSize="inherit"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                            this.showMessage(<Legal.LoyaltyProgram />, 'info', true, 'Condiciones tarjeta fidelización');
                        }}
                    >
                        Consultar condiciones.
                    </Link>
                </Paper>
                {(this.state.disclamerLoyaltyCard === true || (this.state.customer.loyaltyCode !== undefined && this.state.customerError.loyaltyCode === false)) && (
                    <>
                        <Paper className={this.props.classes.paper}>
                            <div className="checkout-title">Datos de {this.state.storePickUp ? 'facturación' : 'envío'}</div>
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputSemiLong : ''}
                                label="DNI / NIF / Pasaporte / Tarjeta Residencia"
                                margin="normal"
                                name="identifier"
                                required
                                value={this.state.customer.identifier}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.identifier}
                                onBlur={this.onLoyaltyCardFieldsChange}
                            />
                            <br />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputFullwidth : ''}
                                label="Nombre y Apellidos"
                                margin="normal"
                                name="name"
                                required
                                value={this.state.customer.name}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.name}
                            />
                            {/* <TextField
                                className={!this.props.smartphone ? this.props.classes.textInput : ''}
                                label="Nombre"
                                margin="normal"
                                name="name"
                                required
                                value={this.state.customer.name}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.name}
                            />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputSemiSemiLong : ''}
                                label="Primer apellido"
                                margin="normal"
                                name="surname"
                                required
                                value={this.state.customer.surname}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.surname}
                            />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputSemiSemiLong : ''}
                                label="Segundo apellido"
                                margin="normal"
                                name="surname2"
                                required
                                value={this.state.customer.surname2}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.surname2}
                            /> */}
                            <br />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputLong : ''}
                                label="Dirección"
                                margin="normal"
                                name="address"
                                required
                                value={this.state.customer.address}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.address}
                            />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputShort : ''}
                                label="Código Postal"
                                margin="normal"
                                name="postalCode"
                                required
                                disabled={this.state.storePickUp === false}
                                value={this.state.customer.postalCode}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.postalCode}
                            />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInput : ''}
                                label="Población"
                                margin="normal"
                                name="city"
                                required
                                value={this.state.customer.city}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.city}
                            />
                            <br />
                            <MuiPhoneNumber
                                className={!this.props.smartphone ? this.props.classes.textInputLong : ''}
                                defaultCountry="es"
                                regions={'europe'}
                                label="Teléfono móvil"
                                margin="normal"
                                helperText="Recibirá un código por SMS a este número para poder verificar el pedido. Debe incluir prefijo internacional"
                                name="phone"
                                required
                                autoComplete="off"
                                value={this.state.customer.phone}
                                fullWidth={this.props.smartphone}
                                onChange={this.onPhoneChanged}
                                error={this.state.customerError.phone}
                            />
                            <TextField
                                className={!this.props.smartphone ? this.props.classes.textInputSemiLong : ''}
                                label="e-Mail"
                                margin="normal"
                                name="email"
                                type="email"
                                value={this.state.customer.email}
                                fullWidth={this.props.smartphone}
                                onChange={this.onCustomerDataChange}
                                error={this.state.customerError.email}
                            />
                            <br />
                            {/* <em>Recibirá un código por SMS a este número para poder verificar el pedido</em> */}
                            <br /> <br />
                            <Checkbox checked={this.state.disclamerAccepted} color="primary" onChange={this.onToggleDisclammer} name={'disclamerAccepted'} /> <strong>ACEPTO</strong> la{' '}
                            <Link
                                component="a"
                                fontSize="inherit"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    this.showMessage(<Legal.LegalNotice />, 'info', true, 'Política de privacidad');
                                }}
                            >
                                política de tratamiento de datos
                            </Link>
                        </Paper>
                    </>
                )}
                <Paper className={this.props.classes.paperHighlight}>
                    <ShoppingCart
                        cart={this.state.cart}
                        customer={this.state.customer}
                        deliveryDate={this.state.orderDeliveryDate}
                        deliveryTime={this.state.orderDeliveryTime}
                        storePickUp={this.state.storePickUp}
                        smartphone={this.props.smartphone}
                        onAddProduct={this.addToCart}
                        onRemoveProduct={this.removeFromCart}
                        amount={this.state.amount}
                        onCheckout={this.nextStep}
                        checkOutDisabled
                    />
                </Paper>
                {this.state.customerFieldsValid && this.state.disclamerAccepted && (
                    <div className="order-confirm-container">
                        <Button onClick={this.createOrder} color="primary" variant="contained" fullWidth={this.props.smartphone}>
                            Confirmar pedido
                        </Button>
                    </div>
                )}
            </>
        );
    };

    renderVerificationForm = () => {
        return (
            <>
                <div className={this.state.orderVerified === true ? 'order-summary order-summary-completed' : 'order-summary'}>
                    {this.state.orderVerified !== true && <div className="section-title">Finaliza tu pedido</div>}
                    {this.state.orderVerified === true && <div className="section-title">Pedido confirmado</div>}

                    {this.state.orderVerified !== true && (
                        <>
                            <p>
                                Hemos enviado un SMS a tu teléfono móvil <strong>{this.state.customer.phone}</strong> con un código.
                            </p>
                            <TextField label="Introduce el código" margin="normal" name="verificationCode" variant="outlined" value={this.state.verificationCode} onChange={this.onChange} />
                            <br />
                        </>
                    )}
                    {this.state.verificationCode && this.state.orderVerified !== true && (
                        <Button onClick={this.verifyOrder} color="primary">
                            Verificar
                        </Button>
                    )}

                    {this.state.orderVerified === true && (
                        <>
                            <h2>Muchas gracias por confiar en {this.props.smartphone && <br />}Ca Na Paulina</h2>

                            <p>
                                Identificador de tu pedido: <strong>{this.state.orderId}</strong>
                                <br />
                                {this.state.storePickUp ? (
                                    <div className="order-summary-store-pickup-container">
                                        <span>Recogida en tienda</span>
                                        Fecha: <strong>{dateToLocale(this.state.orderDeliveryDate)}</strong>
                                        <br />
                                        Hora: <strong>{this.state.verifiedOrderDeliveryTime}</strong>
                                        <br />
                                        <strong>Dirección de recogida:</strong>
                                        <br />
                                        Can Caimari, 10 07007 Palma de Mallorca
                                        <br />
                                        Tel. +34 971 743 750
                                    </div>
                                ) : (
                                    <>
                                        Fecha de entrega: <strong>{dateToLocale(this.state.orderDeliveryDate)}</strong>
                                    </>
                                )}
                            </p>
                        </>
                    )}
                </div>

                {this.state.orderVerified === true && this.state.storePickUp === false && (
                    <div className="order-summary-card">
                        <img src={icons.card} alt="Tarjeta" />
                        <div>
                            <span>PAGO CON TARJETA DE CRÉDITO A LA ENTREGA</span>El pago se realizará en el momento de la entrega, preferiblemente con tarjeta, para mayor seguridad.
                        </div>
                    </div>
                )}
            </>
        );
    };

    renderNavigation = () => {
        return (
            <>
                <div className="shopping-cart-show-button">
                    {!this.props.smartphone && (
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className={this.props.classes.button}
                            startIcon={
                                <StyledBadge badgeContent={this.state.totalQty} color="secondary">
                                    <ShoppingCartOutlinedIcon />
                                </StyledBadge>
                            }
                            onClick={this.toggleCartVisible}
                        >
                            Ver pedido
                        </Button>
                    )}
                    {this.props.smartphone && (
                        <Fab color="primary" onClick={this.toggleCartVisible}>
                            <StyledBadgeSmartphone badgeContent={this.state.totalQty} color="secondary">
                                <ShoppingCartOutlinedIcon />
                            </StyledBadgeSmartphone>
                        </Fab>
                    )}
                </div>
                {this.state.productsOnSale && this.state.productsOnSale.length > 0 && (
                    <Button onClick={this.handleShowHighlightedProducts} color="secondary" variant="contained" startIcon={<LoyaltyIcon color="primary" />}>
                        Ver ofertas
                    </Button>
                )}
                <div className="section-title">
                    Selecciona tus productos
                    <span className="section-subtitle">Todos los precios son con IVA incluido</span>
                </div>
                {this.state.category === undefined && <CategoriesNavigation categories={this.state.categories} smartphone={this.props.smartphone} onShowCategory={this.showCategory} />}
                {this.state.category !== undefined && (
                    <CategoryProductsNavigation
                        category={this.state.category}
                        products={this.state.products}
                        productsOnSale={this.state.productsOnSale.map((p) => p.id)}
                        smartphone={this.props.smartphone}
                        onAddToCart={this.addToCart}
                        onCloseCategory={this.closeCategory}
                    />
                )}
                <Dialog open={this.state.shoppingCartVisible} onClose={this.toggleCartVisible} maxWidth="lg" fullScreen={this.props.smartphone}>
                    <DialogContent dividers={true}>
                        <ShoppingCart
                            cart={this.state.cart}
                            customer={this.state.customer}
                            deliveryDate={this.state.orderDeliveryDate}
                            deliveryTime={this.state.orderDeliveryTime}
                            storePickUp={this.state.storePickUp}
                            smartphone={this.props.smartphone}
                            onAddProduct={this.addToCart}
                            onRemoveProduct={this.removeFromCart}
                            amount={this.state.amount}
                            onCheckout={this.nextStep}
                            onCloseCart={this.toggleCartVisible}
                        />
                    </DialogContent>
                </Dialog>
            </>
        );
    };

    renderOrdersAssistant() {
        const { classes } = this.props;
        const steps = this.getSteps();
        const { activeStep } = this.state;
        return (
            <div className={this.props.classes.root}>
                <div className="header-container">
                    <img src={logo} alt="Ca Na Paulina" className="logo" />
                    <Stepper className="stepper" classes={{ root: classes.stepper }} activeStep={activeStep} alternativeLabel>
                        {steps.map((label, i) => {
                            return (
                                <Step key={label}>
                                    {activeStep !== 3 && (
                                        <StepButton onClick={() => this.goToStep(i)} completed={activeStep > i}>
                                            {!this.props.smartphone && <span className={`step-label ${i === activeStep ? 'step-label-active' : ''}`}>{label}</span>}
                                        </StepButton>
                                    )}
                                    {activeStep === 3 && (
                                        <StepLabel>{!this.props.smartphone && <span className={`step-label ${i === activeStep ? 'step-label-active' : ''}`}>{label}</span>}</StepLabel>
                                    )}
                                </Step>
                            );
                        })}
                    </Stepper>
                </div>
                <div className="content-container">
                    {activeStep === 0 && this.renderRouteForm()}
                    {activeStep === 1 && this.renderNavigation()}
                    {activeStep === 2 && this.renderCustomerForm()}
                    {activeStep === 3 && this.renderVerificationForm()}
                </div>

                <Dialog
                    open={this.state.productsOnSale && this.state.productsOnSale.length > 0 && this.state.showHighlightedProducts && this.state.activeStep === 1}
                    maxWidth="xs"
                    onClose={this.handleCloseHighlightedProducts}
                    fullScreen={this.props.smartphone}
                    fullWidth={true}
                >
                    <HighlightedProducts products={this.state.productsOnSale} smartphone={this.props.smartphone} onAddToCart={this.addToCart} onClose={this.handleCloseHighlightedProducts} />
                </Dialog>
            </div>
        );
    }

    renderHome() {
        return (
            <>
                <div className="home-banner-container" style={{ backgroundImage: `url(${bannerHome})` }}>
                    <div className="home-banner-container-box">
                        <img src={logo} alt="Ca Na Paulina" className="home-banner-container-logo" />
                        <span className="home-banner-container-title">CA NA PAULINA, DIRECTO A TU CASA</span>
                        <br />
                        <span className="home-banner-container-subtitle">
                            Disfruta de nuestros productos,
                            <br />
                            con la máxima comodidad. <br />
                            Pedido minímo de 50 € para envío a domicilio.
                        </span>
                    </div>
                </div>
                <div className="home-red-wide-content-container">
                    <div className="home-content-container">
                        <span className="home-content-container-title">{!this.state.homeDeliveryStep ? '¡Haz tu pedido online y recíbelo cómo tú quieras!' : '¿Dónde quieres redibir tu pedido?'}</span>
                        <br />
                        <br />{' '}
                        {!this.state.homeDeliveryStep && (
                            <div className="home-delivery-options-container">
                                <div className="home-delivery-options" onClick={this.setHomeDelivery}>
                                    <div className="home-delvery-options-domicilio" />
                                    <span>Envío a domicilio</span>
                                </div>
                                <div className="home-delivery-options" onClick={this.checkStorePickup}>
                                    <div className="home-delvery-options-recogida" />
                                    <span
                                        sx={{
                                            textAlign: 'left',
                                        }}
                                    >
                                        Recogida en tienda
                                    </span>
                                </div>
                            </div>
                        )}
                        {this.state.homeDeliveryStep && (
                            <>
                                <div className="start-process-block">
                                    <form onSubmit={this.checkPostalCode}>
                                        <input
                                            className="input-postal-code"
                                            type="text"
                                            name="postalCode"
                                            value={this.state.customer.postalCode}
                                            onChange={this.onCustomerDataChange}
                                            placeholder="Código postal"
                                        />
                                    </form>

                                    <div
                                        className={`start-process-button ${
                                            this.state.customer.postalCode && this.state.customer.postalCode.trim().length === 5 ? '' : 'start-process-button-disabled'
                                        }`}
                                        onClick={this.checkPostalCode}
                                    >
                                        Empezar
                                    </div>
                                </div>
                                <br />
                                <span className="home-delivery-back" onClick={this.unsetHomeDelivery}>
                                    Volver
                                </span>
                            </>
                        )}
                        <br />
                    </div>
                </div>
                <div className="home-content-container" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <Grid container spacing={2} justify="space-evenly">
                        <Grid xs={this.props.smartphone ? 6 : 4} item>
                            <div className="home-icon">
                                <img src={icons.time} alt="Horeario" />
                                <span>HORARIO</span> Todos los pedidos se entregarán de lunes a sábado, de 9h a 16h.
                            </div>
                        </Grid>
                        <Grid xs={this.props.smartphone ? 6 : 4} item>
                            <div className="home-icon">
                                <img src={icons.precio} alt="Precio" />
                                <span>PRECIOS</span>El precio puede variar en función del corte o tamaño. El IVA correspondiente está incluido.
                            </div>
                        </Grid>
                        <Grid xs={this.props.smartphone ? 6 : 4} item>
                            <div className="home-icon">
                                <img src={icons.movil} alt="Confirmación Compra" />
                                <span>CONFIRMACIÓN DE LA COMPRA</span>La compra se cobrará en el momento de la entrega, preferiblemente con tarjeta.
                            </div>
                        </Grid>
                        <Grid xs={this.props.smartphone ? 6 : 4} item>
                            <div className="home-icon">
                                <img src={icons.pago} alt="Pago" />
                                <span>PAGO</span>La compra se cobrará en el momento de la entrega, preferiblemente con tarjeta.
                            </div>
                        </Grid>
                        <Grid xs={this.props.smartphone ? 6 : 4} item>
                            <div className="home-icon">
                                <img src={icons.truckT} alt="Envío gratuito" />
                                <span>ENVÍO GRATUITO</span>El pedido mínimo para disponer de envío a domicilio es de 50 €. El servicio es gratuito.
                            </div>
                        </Grid>
                        <Grid xs={this.props.smartphone ? 6 : 4} item>
                            <div className="home-icon">
                                <img src={icons.puntos} alt="Tarjeta de puntos" />
                                <span>ACUMULA PUNTOS</span>Utiliza tu tarjeta de fidelización para confirmar tus datos, y acumula puntos para próximas compras.
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className="approximate-price-disclamer-container">
                    <div className="approximate-price-disclamer">
                        <div className="approximate-price-disclamer-text">
                            <span className="approximate-price-disclamer-text-title">Todos nuestros precios son aproximados</span>
                            <br />
                            El nuestro es un trabajo artesanal realizado por nuestros carniceros, y por tanto, el precio de las bandejas puede variar según el tipo de corte o el tamaño de producto.{' '}
                            <br /> <br />
                            <em>Todos nuestros precios incluyen IVA</em>
                        </div>
                    </div>
                </div>
                <div className="home-content-container">
                    <div className="home-content-faqs ">
                        <span className="home-content-container-title home-faqs-title">Preguntas frecuentes #CaNaPaulinaEnCasa</span>
                        <br />
                        <br />
                        <Home.FAQs />
                    </div>
                </div>

                <div className="home-content-container" style={{ color: '#000' }}>
                    {/* <div style={{ color: '#000' }}>
                        <span className="home-content-container-title" style={{ color: '#000' }}>
                            SITUACIÓN EXCEPCIONAL COVID-19
                        </span>
                        <br />
                        Te ofrecemos la máxima tranquilidad en tus pedidos: hemos adoptado estrictas medidas de higiene alimentaria para asegurar que tu compra sea 100% segura.
                    </div>
                    <br />
                    <br />
                    Si tienes cualquier duda o incidencia en el momento de la compra, o bien no encuentras lo que estás buscando, llámanos al 971 743 750. */}
                </div>
            </>
        );
    }

    render() {
        return (
            <div className="vertical-container">
                {(this.state.orderAvailableDates.length > 0 || this.state.storePickUp === true) && this.renderOrdersAssistant()}
                {this.state.orderAvailableDates.length === 0 && this.state.storePickUp === false && this.renderHome()}

                <div className="legal-footer">
                    <div>
                        <a href="https://canapaulina.es/aviso-legal.html" target="_blank">
                            Aviso legal
                        </a>
                        <p>© CA NA PAULINA Todos los derechos reservados.</p>
                    </div>
                </div>

                <div className="snackbar">
                    <Slide direction="up" in={this.state.alertOpen} mountOnEnter unmountOnExit>
                        <div className="snackbar-message">
                            <MuiAlert severity={this.state.alertSeverity}>{this.state.alertMessage}</MuiAlert>
                        </div>
                    </Slide>
                </div>

                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleCloseAllDialogs}
                    maxWidth={this.props.dialogSize}
                    fullScreen={this.props.smartphone && typeof this.state.alertMessage !== 'string'}
                >
                    {this.state.dialogTitle && <DialogTitle id="alert-dialog-slide-title">{this.state.dialogTitle}</DialogTitle>}
                    <DialogContent>
                        {typeof this.state.alertMessage !== 'string' && <div>{this.state.alertMessage}</div>}
                        {typeof this.state.alertMessage === 'string' && <DialogContentText>{this.state.alertMessage}</DialogContentText>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseAllDialogs} color="primary">
                            Aceptar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(styles)(OrdersInternal);
